import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Spacer,
  Spinner,
  useMediaQuery,
} from "@chakra-ui/react";
import { TbAdjustmentsHorizontal } from "react-icons/tb";
import { FaSearch } from "react-icons/fa";
import Heading from "ui/Heading";
import Text from "ui/Text";
import theme from "ui/theme/theme";
// import SeoTags from 'components/SEO/SeoTags';
import { StyledTable, StyledTd, StyledTh, StyledTr } from "./Management.styles";
import SelectorIcon from "ui/SelectorIcon";
// import axios from 'axios';
import { convertLocalDateTime } from "utils/dynDateUtils";
import Pagination from "components/Pagination/Pagination";
import RelayFilterPanel from "./components/RelayFilterPanel";
import PromptActionMenu from "./components/PromptActionMenu";
import {
  RELAY_LEVEL_MAP,
  // PROMPT_STATUS_MAP,
  GENRE_MAP,
} from "utils/data/options";

const SORT_BY_COLUMN = ["updated_time"];
const DefaultFilters = Object.freeze({ statusFilters: [], levelFilters: [] });
const PAGE_SIZE = 20;

// import { storyPromptData } from './data/promptData';

function RelayPromptManagement() {
  const navigate = useNavigate();
  const [prompts, setPrompts] = useState([]);
  const [promptCount, setPromptCount] = useState(0);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [filters, setFilters] = useState(
    JSON.parse(JSON.stringify(DefaultFilters))
  );
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [asc, setAsc] = useState(true);
  const [isDesktop] = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);

  const params = qs.parse(useLocation().search, {
    ignoreQueryPrefix: true,
    decoder: (c) => c,
  });

  async function searchPrompts(keywords) {
    setIsSearching(true);
    setFilters({ ...filters, keywords });
  }

  async function getPrompts() {
    const statusList = [];
    filters.statusFilters?.map((item) => {
      // statusList.push(PROMPT_STATUS_MAP[item]);
      statusList.push(item);
    });

    const levelList = [];
    filters.levelFilters?.map((item) => {
      levelList.push(RELAY_LEVEL_MAP[item]);
    });

    const reqestBody = {
      keywords: filters?.keywords ?? "",
      levels: levelList,
      statuses: statusList,
      genre: GENRE_MAP[filters?.genre ?? ""],
      page: page - 1,
      size: PAGE_SIZE,
      sortBy: params?.sortName,
      ascending: asc,
    };
    // console.log('==========request boy: ', reqestBody);

    api
      .post(`${API_BASE}/api/relay-prompt/search`, reqestBody)
      .then((res) => {
        if (res.status == 200) {
          console.log("+++++++++, search replay prompts response: ", res.data);
          setPrompts(res.data?.prompts);
          setPromptCount(res.data?.total);
        }
      })
      .catch((err) => console.log("failed to fetch relay prompts: ", err))
      .finally(() => setIsSearching(false));
  }

  useEffect(() => {
    getPrompts();
  }, [page, filters, asc]);

  function updateParams(newParams) {
    const updatedParams = { ...params, ...newParams };
    const stringifiedParams = qs.stringify(updatedParams, {
      skipNulls: true,
      format: "RFC1738",
      encode: false,
    });
    navigate(`?${stringifiedParams}`, { replace: true });
  }

  function handleSortClick(key) {
    if (params.sortName === key) {
      setAsc((prev) => !prev);
    } else {
      setAsc(true);
    }
  }

  function handleSearch(e) {
    if (e.code === "Enter") {
      searchPrompts(e.target.value);
    }
  }

  function ResultModule() {
    return <div>Result Module</div>;
  }

  function filtersNumber() {
    let number = 0;
    if (filters?.statusFilters?.length) {
      number += 1;
    }
    if (filters?.levelFilters?.length) {
      number += 1;
    }
    if (filters?.genre) {
      number += 1;
    }
    return "(" + number + ")";
  }

  function updatePromptStatus(promptId, status) {
    api
      .patch(`${API_BASE}/api/relay-prompt/status?promptId=${promptId}&status=${status}`)
      .then((res) => {
        if (res.status === 200) {
          // console.log(
          //   'successfully update prompt: ' + promptId + ' status to: ' + status
          // );
          getPrompts();
        }
      });
  }

  return (
    <Box>
      {/* <SeoTags t="Video Management | Dynivy Academy" /> */}
      <HStack>
        <Heading variant="h2">Replay Prompt Management</Heading>
        <Spacer />
        <Button
          as={Link}
          to={`/create-relay-prompt`}
          variant="outline"
          colorScheme="green"
        >
          New Prompt
        </Button>
      </HStack>

      {promptCount && promptCount > 0 ? (
        <>
          <Flex
            alignItems="center"
            mt="32px"
            mb="24px"
            justifyContent="space-between"
          >
            <InputGroup w="60%">
              <InputLeftElement ml="10px" mt="6px">
                {isSearching ? (
                  <Spinner />
                ) : (
                  <FaSearch
                    onClick={() => searchPrompts(query)}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </InputLeftElement>
              <Input
                // ref={searchRef}
                id="searchPrompts"
                onKeyDown={handleSearch}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                paddingLeft="56px"
                type="text"
                placeholder="Search relay title, starter, id, etc."
                maxW={{ base: "unset", md: "354px" }}
                w="100%"
                h="48px"
                _placeholder={{ fontSize: "1rem" }}
                // borderRadius="52px"
                bg="gray.50"
              />
            </InputGroup>
            <Flex>
              {/* {isDesktop && (
                <Button onClick={onOpenExport} variant="primary-1" ml="12px">
                  Export Report
                </Button>
              )} */}
              <Flex
                as="button"
                p={isDesktop ? "12px 18px" : "6px 8px"}
                ml="12px"
                alignItems="center"
                background="gray.50"
                border={`1px solid ${theme.colors.gray[200]}`}
                borderRadius="4px"
                _hover={{ bg: "gray.300" }}
                onClick={() => setFilterDrawerOpen(true)}
              >
                <Text size="medium" mr="10px" fontWeight="bold">
                  Filters {filtersNumber()}
                </Text>
                <TbAdjustmentsHorizontal size="24px" />
              </Flex>
            </Flex>
          </Flex>
          {!isDesktop && (
            <Flex mb="24px">
              <ResultModule />
            </Flex>
          )}
          {isDesktop ? (
            <StyledTable>
              <StyledTr>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Title / Starter
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Genre
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Level
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Status
                  </Text>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Flex alignItems="center">
                    <Text size="medium" fontWeight="bold" mr="8px">
                      Updated Time
                    </Text>
                    <Flex
                      as="button"
                      type="button"
                      onClick={() => {
                        updateParams({ sortName: SORT_BY_COLUMN[0] });
                        handleSortClick(SORT_BY_COLUMN[0]);
                      }}
                    >
                      <SelectorIcon
                        asc={asc}
                        selected={params.sortName === SORT_BY_COLUMN[0]}
                      />
                    </Flex>
                  </Flex>
                </StyledTh>
                <StyledTh className="leftAlign" isGray p="20px 14px">
                  <Text size="medium" fontWeight="bold" mr="8px">
                    Action
                  </Text>
                </StyledTh>
              </StyledTr>
              <tbody>
                {prompts &&
                  prompts?.map((item, idx) => (
                    <StyledTr key={item.promptId}>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text
                          size="medium"
                          color="semantics.link"
                          fontWeight="bold"
                        >
                          <Link to={`/relay-prompt/${item.promptId}`}>
                            {item.promptTitle || item.promptId}
                          </Link>
                        </Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.genre}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.level}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">{item.status}</Text>
                      </StyledTd>
                      <StyledTd isEven={idx % 2 === 0} p="8px 14px">
                        <Text size="medium">
                          {convertLocalDateTime(item.updatedTime)}
                        </Text>
                      </StyledTd>
                      <StyledTd
                        isEven={idx % 2 === 0}
                        className="leftAlign"
                        p="8px 14px"
                      >
                        <Flex
                          justifyContent="center"
                          cursor="pointer"
                          as="button"
                        >
                          {/* <Text>Action Here</Text> */}
                          <PromptActionMenu
                            prompt={item}
                            updatePromptStatus={updatePromptStatus}
                          />
                        </Flex>
                      </StyledTd>
                    </StyledTr>
                  ))}
              </tbody>
            </StyledTable>
          ) : null}
        </>
      ) : null}
      <Flex justifyContent="center">
        <Pagination
          activePage={page}
          pageSize={PAGE_SIZE}
          totalItemCount={promptCount}
          pagesRange={5}
          onChange={setPage}
        />
      </Flex>
      <RelayFilterPanel
        isOpen={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        currentFilters={filters}
        setFilters={setFilters}
        isPrompt={true}
      />
    </Box>
  );
}

export default RelayPromptManagement;
